module.exports = __webpack_public_path__ + "img/w3_location_light.8045d25b.png";